import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { CdnIcon } from '@shared/ui';
import { CloseButton } from '../../../../../BaseComponents';
const ExchangeRefundMobileBreadcrumbs = ({ className, breadcrumbs }) => {
    const { ExchangeRefundMobileBreadcrumbs: css } = useTheme('Entities').Order;
    return (React.createElement("div", { className: cn(css.root, className) }, !!(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) &&
        breadcrumbs.map(({ label, description, icon, disabled, onAction }, index) => (React.createElement("div", { key: `${index}-${label}`, className: css.breadcrumb },
            React.createElement("div", { className: css.leftBlock },
                !!icon && React.createElement(CdnIcon, { className: css.icon, icon: icon }),
                React.createElement("div", { className: css.content },
                    !!label && React.createElement("span", { className: css.label }, label),
                    !!description && React.createElement("span", { className: css.description }, description))),
            !!onAction && (React.createElement(CloseButton, { classes: { root: css.closeButton }, variant: "closePopup", onClick: onAction, disabled: disabled })))))));
};
export default ExchangeRefundMobileBreadcrumbs;
